export const VIDEO_SECTIONS = [
  'General',
  'Installation Reporting',
  'Rollout Progress',
] as const;

export type VideoSection = (typeof VIDEO_SECTIONS)[number];

export interface VideoInstruction {
  title: string;
  url: string;
  section: VideoSection;
}

export interface VideoInstructionSectionGroup {
  section: VideoSection;
  videos: VideoInstruction[];
}

export const VIDEO_LIBRARY: VideoInstruction[] = [
  {
    title: 'Selfinspection cabinet well',
    url: 'https://www.youtube.com/embed/iVu0NMVhZ3Q?si=GqGoboMGAKYZYby3',
    section: 'Rollout Progress',
  },
  {
    title: 'Delivery Overview',
    url: 'https://www.youtube.com/embed/4qNTvoSEXUk?si=QAuj4aQDUfBYHnsp',
    section: 'General',
  },
  {
    title: 'Filtering Installation Reporting',
    url: 'https://www.youtube.com/embed/A92MlvnjRB8?si=eMUU60EsDJBkvvdJ',
    section: 'Installation Reporting',
  },
  {
    title: 'Viewing HUB & Site Delivery Portal',
    url: 'https://www.youtube.com/embed/RQtfMzlohbY?si=tcvpv8ppFgAjjmkc',
    section: 'General',
  },
  {
    title: 'Installation Reporting Version 2 (Finland & Sweden)',
    url: 'https://www.youtube.com/embed/Y0D40TM0Cig?si=f7-hjnkSK-SEDV9W',
    section: 'Installation Reporting',
  },
  {
    title: 'Delivery Portal - Rollout Progress Search Feature',
    url: 'https://www.youtube.com/embed/e4YKOdsDXO0?si=oopWEdUkVD0QBY_T',
    section: 'Rollout Progress',
  },
  {
    title: 'Self-inspection SITE HUB',
    url: 'https://www.youtube.com/embed/XDjTtdNfcxc?si=sSTolDTtGpOVmbe9',
    section: 'General',
  },
  {
    title: 'Installation Reporting Signing',
    url: 'https://www.youtube.com/embed/v61tJPkiieM?si=nV5XcIlAZncjNBH1',
    section: 'Installation Reporting',
  },
  {
    title: 'Self-inspections Spans',
    url: 'https://www.youtube.com/embed/zzHbDdqznX0?si=TyTqRb1kch5z0cla',
    section: 'Rollout Progress',
  },
  {
    title: 'MultiSpan Reporting',
    url: 'https://www.youtube.com/embed/zQTDNsl6aL4?si=3rvTkmwyxOMNDsFJ',
    section: 'Rollout Progress',
  },
  {
    title: 'DeliveryPortal February Updates',
    url: 'https://www.youtube.com/embed/0uppjKZVFaw?si=eglqkWpHCopKgvd2',
    section: 'General',
  },
  {
    title: 'DeliveryPortal Preview PDF and more',
    url: 'https://www.youtube.com/embed/OQgTPE_xxDs?si=igVysfMSDv_RMvQF',
    section: 'General',
  },
];

export function getVideosGroupedBySection(
  videos: VideoInstruction[] = VIDEO_LIBRARY,
): VideoInstructionSectionGroup[] {
  return VIDEO_SECTIONS.map((section) => ({
    section,
    videos: videos.filter((video) => video.section === section),
  })).filter((group) => group.videos.length > 0);
}
